import React from 'react';
import GrayButton from '../Utils/GrayButton';

const ModalOrderDetail = ({ isOpen, onClose, orderData }) => {
  if (!isOpen) return null;

  const rawText = orderData?.maps_url || 'No hay detalles disponibles para este pedido.';

  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    
    // Evitar que la pantalla haga scroll al final
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        alert('Información copiada al portapapeles');
      } else {
        alert('No se pudo copiar automáticamente. Por favor, selecciona y copia el texto manualmente.');
      }
    } catch (err) {
      console.error('Error en fallback de copiado:', err);
      alert('Error al copiar la información');
    }

    document.body.removeChild(textArea);
  };

  const copyToClipboard = () => {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(rawText);
      return;
    }
    
    navigator.clipboard.writeText(rawText).then(() => {
      alert('Información copiada al portapapeles');
    }).catch(err => {
      console.error('Error al usar clipboard API: ', err);
      fallbackCopyTextToClipboard(rawText);
    });
  };

  // Format WhatsApp text: convert *bold* into <strong>bold</strong>
  const formatWhatsAppText = (text) => {
    if (!text) return null;
    
    // Split text using regex that captures *text* 
    const parts = text.split(/(\*[^*]+\*)/g);
    
    return parts.map((part, index) => {
      if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
        return <strong key={index} className="font-bold text-gray-900">{part.slice(1, -1)}</strong>;
      }
      return <span key={index}>{part}</span>;
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="p-8">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">
              Detalle de Venta
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {orderData && (
            <div className="space-y-8">
              <div className="bg-gray-50 p-6 md:p-8 rounded-xl border border-gray-200 shadow-inner">
                <div className="font-sans text-gray-800 text-base md:text-lg leading-relaxed whitespace-pre-wrap">
                  {formatWhatsAppText(rawText)}
                </div>
              </div>

              {/* Actions */}
              <div className="flex justify-between pt-4 border-t border-gray-200">
                <button
                  onClick={copyToClipboard}
                  className="px-4 py-2 bg-green-500 hover:bg-green-600 text-white font-medium rounded-md shadow-sm transition-colors flex items-center"
                >
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                  </svg>
                  Copiar para WhatsApp
                </button>
                <GrayButton onClick={onClose}>
                  Cerrar
                </GrayButton>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalOrderDetail;
